

import React from 'react';
import { Formik, Form, useField } from 'formik';
import * as Yup from 'yup';
import { axiosFetch } from '../../../utils/apiUtils';
const TextInput = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    console.log(label)
    console.log(props)
    console.log(field)
    console.log(meta)
    return (<form>
        <label>{label}</label>
        <input {...field}{...props} value={Formik.values}/><br />
        <br></br>
        {meta.touched && meta.error ? (
            <div >{meta.error}</div>
        ) : null}
    </form>
    )
}
async function SignUpPageValues(values) {
    try {
        const response = await axiosFetch.post("accounts/signup/",values)
        console.log(response)
    }
    catch (error) {
        console.error(error)
    }
}

const SignUpPage = () => {
    return (
        <Formik
        initialValues={{
            email: '',
            first_name: '',
            last_name: '',
            username: '',
            password: '',
        }
        }
            validationSchema={
                Yup.object({
                    first_name: Yup.string()
                        .max(15, "maximum 15 character")
                        .required('required'),
                    last_name: Yup.string()
                    .min(3,"Atleast 3 character")
                        .max(10, "maximum 10 character")
                        .required('required'),
                    email: Yup.string()
                        .email("Invalid email address")
                        .required('required'),
                    username: Yup.string()
                        .max(10, "maximum 10 character")
                        .required('required'),
                    password: Yup.string()
                        .min(5,"minimum 5 characer required")
                        .required('required'),
                })
            }

          onSubmit={(values) => {
            console.log(values)
            SignUpPageValues(values)
          }}
        >
            <Form>
                <TextInput
                    label="First Name"
                    name="first_name"
                    type="text"
                />

                <TextInput
                    label="Last Name"
                    name="last_name"
                    type="text"
                />

                <TextInput
                    label="Email"
                    name="email"
                    type="email"
                />

                <TextInput
                    label="Password"
                    name="password"
                    type="password"
                />

                <TextInput
                    label="UserName"
                    name="username"
                    type="text"
                />
                <button type="submit">Submit</button>
            </Form>
          

        </Formik>
        
          
    )
}
export default SignUpPage;

